"use client";

import dynamic from "next/dynamic";

// Dynamically import VisualEditing only when needed (draft mode)
// This prevents the @sanity/visual-editing bundle from being included in production
// Using ssr: false since this is a client component
const VisualEditing = dynamic(
  () => import("@sanity/visual-editing/react").then((mod) => mod.VisualEditing),
  {
    ssr: false,
  },
);

interface VisualEditingWrapperProps {
  enabled: boolean;
}

export default function VisualEditingWrapper({
  enabled,
}: VisualEditingWrapperProps) {
  if (!enabled) return null;
  return <VisualEditing portal />;
}
